import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dq-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent implements OnInit {
  @Input()
  id: string = '';

  @Input()
  idChild!: NgbCollapse;

  @Input()
  icon: string = '';

  @Input()
  label: string = '';

  public isCollapsed = false;

  constructor(translate: TranslateService) {}

  ngOnInit(): void {
    //console.log('idChild' + this.idChild);
  }
}
